<template>
    <!-- 
        1. user has trail
        2. get webhook from stripe when trials ends, and set to show trial alert
        3. set user as free and give him pay link
        4. user can pay or cancel subscription    
    -->
    <div v-hotkey="keyMap">
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.1/dist/css/bootstrap.min.css" rel="stylesheet"
            integrity="sha384-+0n0xVW2eSR5OomGNYDnhzAbDsOXxcvSN1TPprVMTNDbiYZCxYbOOl7+AMvyTG2x" crossorigin="anonymous">
        <div v-show="modal" id="myModal" class="modal" @click.self="changeModal" ref="modalContent">
            <div class="modal-content">
                <div class="modal-header">
                    <h1>{{ title }}</h1>
                    <svg v-if="!is_for_sub_user" @click="changeModal" xmlns="http://www.w3.org/2000/svg" width="33" height="33"
                        viewBox="0 0 33 33" fill="none">
                        <path d="M8.25 24.75L24.75 8.25M8.25 8.25L24.75 24.75" stroke="#5C5C5C" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="modal-body">
                    <div class="left">
                        <img v-if="trial_alert" src="/img/doggo_trial.png" style="width:290px; height:250px;"/>
                        <img v-else src="/img/doggo_subs.png" />
                    </div>
                    <div class="right">
                        <p v-html="text" :style="{'width': trial_alert ? '100%' : '85%'}">
                        </p>
                        <div v-if="!is_for_sub_user && !trial_alert">
                            <max-offer-client :numerator="numerator" :denominator="denominator"
                            :title="counter_title"></max-offer-client>
                            <div class="btns">
                                <div class="close" @click="changeModal">
                                    {{ $t('stripe.alert_close') }}
                                </div>
                                <div class="buy" @click="buy">
                                    {{ $t('stripe.alert_manage_sub') }}
                                </div>
                            </div>
                        </div>
                        <div v-if="trial_alert">
                            <div class="btns mb-20px">
                                <div class="buy smaller" @click="pay">
                                    {{ $t('stripe.alert_renew') }} {{ old_product_name }}
                                </div>
                                <div class="buy" @click="buy">
                                    {{ $t('stripe.alert_manage_sub') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MaxOfferClient from '../../../../layouts/Header/MaxOfferClient.vue';
export default {
    components: { MaxOfferClient },
    props: ['openModal', 'offer_count', 'is_for_sub_user', 'trial_alert', 'pay_link', 'old_product_name'],
    data() {
        return {
            modal: true,
            title: "",
            text: "",
            numerator: 0,
            denominator: 0,
            counter_title: ""
        }
    },
    mounted() {
        this.counter_title = this.$t('stripe.alert_offers_counter')
        this.title = this.$t('stripe.alert_upgrade_title')
        this.text = this.$t('stripe.alert_upgrade_text')
        this.numerator = this.offer_count
        this.denominator = 3
        if(this.is_for_sub_user){
            this.title = this.$t('stripe.alert_main_upgrade')
            this.text = "Od 1. mája 2025 prechádza DOFFERO na nový platený model. <b>Aby si mohol/la využívať tento účet, je potrebné aby hlavný účet <a class='text-normal' href='mailto:" + this.is_for_sub_user + "'>" + this.is_for_sub_user + "</a> prešiel na vyšší balíček.</b><br><br> <a href='/cennik'>Viac info</a>"
        }
        if(this.trial_alert){
            this.title = this.$t('stripe.alert_trial_ended')
            this.text = this.$t('stripe.alert_trial_text')
        }
    },
    computed: {
        keyMap() {
            return {
                'F12': this.cennik,
                'ctrl+shift+i': this.cennik,
                'ctrl+shift+j': this.cennik,
                'ctrl+shift+c': this.cennik,
            }
        }
    },
    methods: {
        cennik() {
            window.location.href = "/cennik"
        },
        buy() {
            window.location.href = "/admin/subscriptions/dashboard"
        },
        pay() {
            window.location.href = this.pay_link
        },
        changeModal() {
            if(this.is_for_sub_user){
                return;
            }
            this.modal = !this.modal
            if (this.modal) {
                this.$refs.videoRef.play();
            } else {
                document.documentElement.style.overflow = 'auto';
                this.$emit('closeModal', false);
            }
        },
    },
    watch: {
        'openModal': function () {
            if (this.openModal) {
                this.changeModal()
            }
        },
    }
}
</script>

<style lang="scss">
.modal-body {
    p {
        strong {
            font-weight: 900;
        }

        a {
            color: #F93C34 !important;
        }

        .text-normal {
            color: #6B6F8C !important;
        }
    }
}
</style>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap');

* {
    font-family: 'Roboto', sans-serif;
}


.modal {
    display: block;
    position: fixed;
    z-index: 1089;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background: rgba(33, 37, 65, 0.89);
    backdrop-filter: blur(5px);

    .modal-content {
        margin: 100px auto 100px auto;
        background: #F7F7F7;
        width: 700px;
        border-radius: 4px;
        box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.05);

        @media (max-width: 600px) {
            width: 95% !important;
            margin: 50px auto 50px auto;
        }

        .modal-line {
            width: 673px;
            height: 1px;
            background: #D73C78;

            @media (max-width: 600px) {
                width: 100% !important;
            }
        }

        .modal-header {
            margin: 35px auto 20px auto;
            width: 648px;
            display: flex;
            align-items: center;
            padding: 0;
            border: none;

            @media (max-width: 600px) {
                width: 100% !important;
            }

            h1 {
                width: 450px;
                height: 34px;
                text-align: left;
                font-family: Roboto;
                font-size: 29px;
                font-style: normal;
                font-weight: 300;
                line-height: normal;
                color: #212541;

                @media (max-width: 600px) {
                    width: 100% !important;
                }
            }

            svg {
                transition: transform .5s;

                &:hover {
                    cursor: pointer;
                    transform: scale(1.3);
                }
            }
        }

        .modal-body {
            padding: 0;
            background-color: #F7F7F7;
            display: flex;
            justify-content: center;
            gap: 20px;
            padding: 0 60px;

            .left {
                img {
                    max-width: none;
                    width: 200px;
                    height: 100%;
                    transform: translateY(1px);
                }
            }

            .right {
                display: flex;
                flex-direction: column;
                justify-content: center;
                gap: 8px;

                p {
                    font-family: Montserrat;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 20px;
                    color: #6B6F8C;
                    width: 85%;

                    strong {
                        font-weight: 700;
                    }

                    a {
                        color: #F93C34 !important;
                    }
                }

                .btns {
                    display: flex;
                    align-items: center;
                    gap: 20px;

                    .close {
                        width: 83px;
                        height: 47px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border: 2px solid #E5E7EB;
                        border-radius: 8px;
                        font-family: Montserrat;
                        font-weight: 700;
                        font-size: 14px;
                        line-height: 20px;
                        color: #000000;
                        cursor: pointer;
                    }

                    .buy {
                        width: 169px;
                        height: 47px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background-color: #2ED8B6;
                        border-radius: 8px;
                        font-family: Montserrat;
                        font-weight: 700;
                        font-size: 14px;
                        line-height: 20px;
                        color: #fff;
                        cursor: pointer;
                        &.smaller {
                            width: 150px;
                            height: 47px;
                            background-color: #F93C34;
                            &:hover {
                                background-color: #e0362c;
                            }
                        }
                        &:hover {
                            background-color: #29c2a3;
                        }
                    }
                }
            }
        }
    }
}
</style>
